import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import SelectAccreditations from 'react-select';
import SelectChapters from 'react-select';
import { getSlug, } from "../../../config/routes/guards/slug";
import { formatDate } from '../../../helpers/formatDate';
import Table from 'react-bootstrap/Table';
import { IconTrash } from '@tabler/icons-react';

const MappingBabUserComp = (props) => {
  // console.log(props.user)
  const [accreditations, setAccreditations] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [disableCheckAll, setDisableCheckAll] = useState(true);
  const [disableSelectChapter, setDisableSelectChapter] = useState(true);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [accreditaion, setAccreditaion] = useState({});
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [mappedChapters, setMappedChapters] = useState([]);

  const fetchAccreditations = async () => {
    try {
      const options = {
        url: `/standards/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setAccreditations([]);
      // console.log(data)
      data.map((item) =>
        setAccreditations((row) => [
          ...row,
          {
            // label: `${formatDate(item.TglMulai)} s/d ${formatDate(item.TglBerakhir)}`,
            label: item.Nama,
            value: item.id,
          },
        ])
      );
    } catch (err) {
      console.log(err);
    }
  };

  const fetchMappingChapters = async () => {
    try {
      const options = {
        url: `/muc/list-by-user/${props?.user?.id}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setMappedChapters(data)
    } catch (err) {
      console.log(err);
    }
  };

  // const fetchChapters = async (paramId) => {
  //   try {
  //     const options = {
  //       url: `/chapters/getListByFk/${paramId}`,
  //       method: 'GET',
  //       headers: {
  //         'Access-Control-Allow-Origin': '*',
  //         Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
  //       },
  //     };
  //     const { data } = await axios(options);
  //     setChapters([]);
  //     data.map((item) =>
  //       setChapters((row) => [
  //         ...row,
  //         {
  //           label: item.Singkatan,
  //           value: item.id,
  //         },
  //       ])
  //     );
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  useEffect(() => {
    fetchAccreditations();
    fetchMappingChapters()
  }, []);

  const handleCreate = () => {

    setLoading(true);
    setDisabled(true);

    const mappings = selectedChapters.map(item => ({
      idBab: item.value,
    }));

    const requestBody = {
      idUser: props?.user?.id,
      IdMasterAkreditasi: accreditaion.value,
      isCheckAll: isCheckAll,
      mappings: mappings,
    };

    // console.log(mappings);
    // return false;
    axios({
      url: '/muc/create',
      method: 'POST',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Mapping berhasil ditambah.',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  const handleChangeAccreditation = async (object) => {
    // console.log(object.value)
    setAccreditaion(object)
    try {
      const options = {
        url: `/chapters/getListByFk/${object.value}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // fetchChapters(data?.IdMasterAkreditasi)

      setDisableSelectChapter(false)
      setDisableCheckAll(false)

      setChapters([]);
      data.map((item) =>
        setChapters((row) => [
          ...row,
          {
            label: item.Singkatan,
            value: item.id,
          },
        ])
      );
    } catch (err) {
      setDisableSelectChapter(false)
      setDisableCheckAll(false)
      console.log(err);
    }

  }

  const handleDelete = (id) => {

    MySwal.fire({
      title: "Apakah anda yakin ?",
      text: "Data akan dihapus permanen",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#26D07C",
      cancelButtonColor: "#191919",
      confirmButtonText: "Ya, Lakukan!",
      cancelButtonText: "Batal"
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          url: `/muc/${id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
        })
          .then(res => {
            // console.log(res)
            // return false
            if (res.status === 200) {
              MySwal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Berhasil menghapus data!'
              })

              fetchMappingChapters()
            }
          })
          .catch(err => {
            if (err !== "") {
              console.log(err?.response?.data?.message)
              MySwal.fire({
                icon: 'error',
                title: 'Oops, Error!',
                text: `${err?.response?.data?.message}`
              })
            }
          })
      }
    });
  }

  const handleSelectAllChapter = (value) => {
    setDisableSelectChapter(!disableSelectChapter)
    setSelectedChapters([])
    setIsCheckAll(value)
  }


  return (
    <>
      <div className="row">
        <h4 className="text-info">Tabel Akses Bab</h4>
        <div className="col-12">
          <Table striped bordered hover>
            <thead className="bg-info border-1 text-center text-white">
              <tr>
                <th>Standard Akreditasi</th>
                <th>Bab</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody className="border-1">
              {mappedChapters?.map((row) => (
                <tr>
                  <td className="text-center">{row?.chapters_accreditation?.standards_accreditation?.Nama}</td>
                  <td>{row?.chapters_accreditation?.Deskripsi} ({row?.chapters_accreditation?.Singkatan})</td>
                  <td>
                    <button
                      onClick={() =>
                        handleDelete(row.id)
                      }
                      className="btn btn-danger btn-sm"
                      type="button"
                    >
                      <IconTrash stroke={2} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      {/* <small className='text-info'>Catatan: Setiap menyimpan mapping akses bab, sistem akan menghapus mapping sebelumnya berdasarkan Standard Akreditasi lalu menambahkan mapping yg terbaru, pastikan kembali daftar akses bab sebelum Simpan.</small> */}
      <hr></hr>
      <h4 className="text-info mb-4">Tambah Akses Bab</h4>
      <div className="mb-3 row">
        <label htmlFor="accreditation" className="col-sm-2 col-form-label required">
          Standard
        </label>
        <div className="col-sm-10">
          <SelectAccreditations
            id="accreditation"
            value={accreditaion}
            onChange={handleChangeAccreditation}
            options={accreditations}
            placeholder="Cari Kegiatan"
          />
          <small className='text-info'>Silakan pilih Standard Akreditasi.</small>
        </div>
      </div>
      <div className="mb-3 row">
        <label
          htmlFor="chapter"
          className="col-sm-2 col-form-label required"
        >
          Bab
        </label>
        <div className="col-sm-10">
          <SelectChapters
            id="chapters"
            value={selectedChapters}
            onChange={setSelectedChapters}
            options={chapters}
            placeholder="Cari Bab"
            isMulti={true}
            isDisabled={disableSelectChapter}
          />
          <small className='text-info'>Silahkan pilih Standard lalu pilih lebih dari 1 Bab.</small>
        </div>
      </div>
      <div className="mb-3 row align-items-center">
        <label
          htmlFor="isCheckAll"
          className="col-sm-2 col-form-label"
        >
          Pilih semua Bab
        </label>

        <div className="col-sm-10">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="isCheckAll"
              checked={isCheckAll}
              onChange={(e) => handleSelectAllChapter(e.target.checked)}
              disabled={disableCheckAll}
            />
          </div>
        </div>
      </div>
      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleCreate()}
          >
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
        </div>
      </div>
    </>
  );
};

export default MappingBabUserComp;
